import { useState } from "react";

export function useLoading(initialState = false) {
  const [loading, setLoading] = useState<boolean>(initialState);

  return { loading, setLoading };
}
